export default "__VITE_ASSET__CkyZr53u__"